<template>
<div>
     <h1 class="sleep pt-5 pl-5 ml-3">Our Product</h1>
     <div class=" pl-5 ml-2 best d-flex flex-row bd-highlight mb-3 justify-content-between">
  <div class="py-2 bd-highlight find">Find your best products</div>
  <div class="py-2 bd-highlight see">SEE ALL PRODUCT</div>
     </div>
</div>
</template>

<script>

export default {
  data () {
    return {
      
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/page1/product.vue